import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActions,
} from '@mui/material';
import {
  Restaurant as Form2Icon,
} from '@mui/icons-material';

function ShipmentFormSelection() {
  const navigate = useNavigate();

  const forms = [
    {
      title: 'Food Waste Intake Form',
      description: 'Step 1: Basic intake information.',
      icon: <Form2Icon sx={{ fontSize: 48 }} />,
      path: '/shipments/new/form2',
    },
    {
      title: 'Additional Food Waste Intake Form',
      description: 'Step 2: Additional intake information.',
      icon: <Form2Icon sx={{ fontSize: 48 }} />,
      path: '/shipments/new/form3',
    },
  ];

  return (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Typography variant="h7" component="h1" gutterBottom>
        Select Intake Form
      </Typography>
      <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 4 }}>
        Choose the appropriate form based on your intake type
      </Typography>

      <Grid container spacing={3}>
        {forms.map((form, index) => (
          <Grid item xs={12} md={4} key={index}>
            <Card 
              sx={{ 
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                transition: 'transform 0.2s',
                '&:hover': {
                  transform: 'translateY(-4px)',
                }
              }}
            >
              <CardContent sx={{ flexGrow: 1 }}>
                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                  {form.icon}
                </Box>
                <Typography variant="h6" component="h2" gutterBottom>
                  {form.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {form.description}
                </Typography>
              </CardContent>
              <CardActions sx={{ p: 2, pt: 0 }}>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={() => navigate(form.path)}
                >
                  Select Form
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default ShipmentFormSelection; 